export const log = (one, two) => {
    if (!two) {
        console.log("------> ", one)
    } else {
        console.log("-> " + one + ' :: ', two)
    }
}

export const logs = (one, two) => console.log(one && two ? one : JSON.stringify(one, null, 2), two ? JSON.stringify(two, null, 2) : '')

/**
 * Creates a change tracking entry for booking edits
 * @param {Object} userMetadata - User metadata object with userId, firstName, lastName
 * @param {Object} options - Options for the change entry
 * @param {string} options.changeType - Type of change (e.g., 'edit', 'waiver_signed', 'check_in', 'admin_notes', 'photo_upload', 'problem_report', 'lock_assignment', 'refund', 'charge')
 * @param {string} options.fieldChanged - Field that was changed (e.g., 'adminNotes', 'waiver', 'bookingIntake', 'media')
 * @param {any} options.oldValue - Previous value (optional, for critical fields)
 * @param {any} options.newValue - New value (optional, for critical fields)
 * @param {string} options.description - Human-readable description of the change (optional)
 * @param {Object} options.timestamp - Firestore Timestamp (will use Timestamp.now() if not provided)
 * @returns {Object|null} - Change tracking entry object or null if no user metadata available
 */
export const createChangeTrackingEntry = (userMetadata, options = {}) => {
  if (!userMetadata || !userMetadata.userId) {
    return null;
  }

  const {
    changeType = "edit",
    fieldChanged = null,
    oldValue,
    newValue,
    description = null,
    timestamp,
  } = options;

  // Build the change entry
  const changeEntry = {
    userId: userMetadata.userId,
    firstName: userMetadata.firstName || "",
    lastName: userMetadata.lastName || "",
    timestamp: timestamp || null, // Caller should provide Timestamp.now()
    changeType,
    fieldChanged,
    description,
  };

  // Add old/new values only if provided (for critical fields)
  if (oldValue !== undefined) {
    changeEntry.oldValue = oldValue;
  }
  if (newValue !== undefined) {
    changeEntry.newValue = newValue;
  }

  return changeEntry;
};

/**
 * Parses booking pickup/delivery options and returns a formatted string
 * @param {Object} booking - The booking object
 * @returns {string} - Formatted string describing pickup/delivery options
 */
export const getPickupOptionsText = (booking) => {
    if (!booking) return "";
    
    const hasDelivery = booking.delivery || false;
    const hasHomePickup = booking.homePickup || false;
    
    // Check for in-store pickup
    const hasInStorePickup = booking.inStorePickup || false;
    
    // Handle combinations based on user requirements:
    // 1. delivery + inStorePickup = "Delivery & In-Store Dropoff" (we deliver, they drop off)
    if (hasDelivery && hasInStorePickup) {
        return "Delivery & In-Store Dropoff";
    }
    // 2. inStorePickup + homePickup = "In-Store Pickup & Pickup" (they pick up, we get them to return)
    else if (hasInStorePickup && hasHomePickup) {
        return "In-Store Pickup & Pickup";
    }
    // 3. delivery + homePickup = "Delivery & Pickup"
    else if (hasDelivery && hasHomePickup) {
        return "Delivery & Pickup";
    }
    // 4. Only inStorePickup = "In-Store Pickup/Dropoff"
    else if (hasInStorePickup) {
        return "In-Store Pickup/Dropoff";
    }
    // 5. Only delivery = "Delivery"
    else if (hasDelivery) {
        return "Delivery";
    }
    // 6. Only homePickup = "Pickup"
    else if (hasHomePickup) {
        return "Pickup";
    }
    
    return "";
}